function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchitect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "architect (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.544,
    height: 48,
    viewBox: "0 0 31.544 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47646",
    d: "M268.564 266.652v23h-7.025v-21.866zm0 0",
    transform: "translate(-237.02 -241.654)",
    style: {
      fill: "#e6f6fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47647",
    d: "M313.941 266.993v22.66h2.112v-23zm0 0",
    transform: "translate(-284.509 -241.654)",
    style: {
      fill: "#cae5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47648",
    d: "M282.1 239.465a2.813 2.813 0 1 1-2.813-2.812 2.813 2.813 0 0 1 2.813 2.812zm0 0",
    transform: "translate(-250.553 -214.466)",
    style: {
      fill: "#9bb8d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47649",
    d: "M263.214 260.844h2.535v3.356h-2.535a1.679 1.679 0 0 1 0-3.357zm0 0",
    transform: "translate(-237.016 -236.39)",
    style: {
      fill: "#cae5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47650",
    d: "M16.218 332.109h-4.526l-5.744 2.5A9.9 9.9 0 0 0 0 343.685v4.926a.363.363 0 0 0 .364.364h27.183a.364.364 0 0 0 .364-.364v-4.926a9.9 9.9 0 0 0-5.949-9.077zm0 0",
    transform: "translate(0 -300.974)",
    style: {
      fill: "#87d1ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47651",
    d: "m156.335 334.608-5.744-2.5h-2.318l5.743 2.5a9.9 9.9 0 0 1 5.949 9.077v4.926a.363.363 0 0 1-.364.364h2.318a.363.363 0 0 0 .363-.364v-4.926a9.9 9.9 0 0 0-5.947-9.077zm0 0",
    transform: "translate(-134.373 -300.974)",
    style: {
      fill: "#5fa6ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47652",
    d: "M115.295 375.4h2.715l1.974 12.806h-6.664zm0 0",
    transform: "translate(-102.697 -340.205)",
    style: {
      fill: "#3a4d7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47653",
    d: "m53.008 335.1 3.369 5.815a.772.772 0 0 0 1.074.27l4.541-2.808v-6.27H59.73c-6.149 2.682-5.921 2.549-6.628 2.937l-.094.056zm0 0",
    transform: "translate(-48.038 -300.974)",
    style: {
      fill: "#c2f4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47654",
    d: "m157.828 335.1-3.369 5.815a.772.772 0 0 1-1.074.27l-4.541-2.808v-6.27h2.263c6.148 2.682 5.92 2.549 6.628 2.937.031.02.071.044.093.056zm0 0",
    transform: "translate(-134.89 -300.974)",
    style: {
      fill: "#c2f4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47655",
    d: "M154.534 334.608a9.884 9.884 0 0 1 2.614 1.669l.68-1.175-.062-.037-.013-.007-.016-.008a12.043 12.043 0 0 0-.194-.107l-.051-.027a9.892 9.892 0 0 0-.23-.116c-.166-.08-.383-.178-.749-.338l-1.333-.58c-.9-.39-2.184-.948-4.074-1.772h-2.262v.023zm0 0",
    transform: "translate(-134.89 -300.974)",
    style: {
      fill: "#87d1ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47656",
    d: "M107.266 268.281v7.619l3.9 4.634 3.9-4.634v-7.619zm0 0",
    transform: "translate(-97.209 -243.13)",
    style: {
      fill: "#ffcca9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47657",
    d: "M107.266 273.06a9.923 9.923 0 0 0 7.8 1.513v-6.292h-7.8zm0 0",
    transform: "translate(-97.209 -243.13)",
    style: {
      fill: "#ffa076"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47658",
    d: "M43.266 145.988v6.156a9.9 9.9 0 0 0 19.8 0v-6.156zm0 0",
    transform: "translate(-39.209 -132.302)",
    style: {
      fill: "#ffcca9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47659",
    d: "M144.839 145.988v6.156a9.9 9.9 0 0 1-8.706 9.828 10.022 10.022 0 0 0 1.193.071 9.9 9.9 0 0 0 9.9-9.9v-6.156zm0 0",
    transform: "translate(-123.37 -132.302)",
    style: {
      fill: "#ffa076"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47660",
    d: "M48.827 10.419v-.738a9.681 9.681 0 0 0-19.362 0v.738a.205.205 0 0 1-.205.205h-.45a1.013 1.013 0 0 0-1.01 1.012v3.142a.29.29 0 0 0 .29.29h22.12a.29.29 0 0 0 .29-.29v-3.142a1.013 1.013 0 0 0-1.013-1.013h-.451a.2.2 0 0 1-.209-.204zm0 0",
    transform: "translate(-25.191)",
    style: {
      fill: "#ffdc61"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12999"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47661",
    d: "M147.525 10.623h-.451a.2.2 0 0 1-.205-.205v-.737A9.687 9.687 0 0 0 135.98.075a9.682 9.682 0 0 1 8.474 9.606v.738a.205.205 0 0 0 .205.205h.451a1.013 1.013 0 0 1 1.013 1.013v3.431h2.125a.29.29 0 0 0 .29-.29v-3.142a1.013 1.013 0 0 0-1.013-1.013zm0 0",
    transform: "translate(-123.232)",
    style: {
      fill: "#f7ad48"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47662",
    d: "M89.671 17.154a.724.724 0 0 0 1.424-.267l-1.135-6.042a9.684 9.684 0 0 0-1.324.8zm0 0",
    transform: "translate(-80.327 -9.827)",
    style: {
      fill: "#f7ad48"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47663",
    d: "M183.312 17.732a.724.724 0 0 0 .846-.578l1.035-5.51a9.68 9.68 0 0 0-1.324-.8l-1.135 6.042a.724.724 0 0 0 .578.846zm0 0",
    transform: "translate(-165.591 -9.827)",
    style: {
      fill: "#f7ad48"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47664",
    d: "M212.056 476.027h-5.283a.7.7 0 0 1 0-1.406h5.283a.7.7 0 1 1 0 1.406zm0 0",
    transform: "translate(-186.751 -430.125)",
    style: {
      fill: "#3a4d7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47665",
    d: "M129.232 91.428a2.264 2.264 0 1 1-2.264-2.264 2.264 2.264 0 0 1 2.264 2.264zm0 0",
    transform: "translate(-113.012 -80.805)",
    style: {
      fill: "#ffeea6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47666",
    d: "M36.055 163.724a80.252 80.252 0 0 1 16.852 0 2.151 2.151 0 0 0 2.371-2.143v-.858h-21.6v.858a2.152 2.152 0 0 0 2.377 2.143zm0 0",
    transform: "translate(-30.526 -145.655)",
    style: {
      fill: "#ffeea6"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitect);
export default __webpack_public_path__ + "static/media/architect.416f6beea7ad5dfc0b655fa5494200fc.svg";
export { ForwardRef as ReactComponent };